import React, { useState } from 'react'
import { Modal, Button, InputGroup, Form } from 'react-bootstrap';
import { insertTableBd } from '../../config/functions'
import { toast } from 'react-toastify'

const ModalEmpleado24 = ({ show, handleClose, getDetalleEmpleados, tipo, idrde }) => {

    const [nombre, setNombre] = useState('')
    const user = JSON.parse(localStorage.getItem("token")).userName;

    //-----------------------------------------------------

    const guardarNueva = async () => {

        if (!nombre.trim()) {
            toast.warning('El nombre no puede estar vacío.');
            return;
        }
        const dataSend = {
            id_rde: parseInt(idrde),
            empleado: nombre.toLocaleUpperCase(),
            cargo: tipo.toLocaleUpperCase(),
            horas: 24,
            horario: '00:00-00:00',
            usuario: user,
        }
        const response = await insertTableBd('createregistrediarioDE', dataSend)
        if (response) {
            await getDetalleEmpleados()
            toast.success( `${tipo} guardado exitosamente`)
            handleClose()
        } else {
            toast.error('Error al guardar los datos.');
        }
    }

    //------------------------------------------------------

    return (
        <Modal show={show} onHide={handleClose} id="alarmModal" aria-labelledby="alarmModalLabel">

            <Modal.Header closeButton>
                <Modal.Title> Adicionar {tipo} </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <InputGroup className="mb-3" size="sm">
                    <InputGroup.Text >{tipo}</InputGroup.Text>
                    <Form.Control
                        type="text"
                        aria-label={tipo}
                        placeholder={tipo}
                        size="sm"
                        onChange={(e) => setNombre(e.target.value)}
                        value={nombre} />
                </InputGroup>

            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={guardarNueva}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalEmpleado24